import { computed } from "vue";
import { usePage } from "@inertiajs/vue3";

const LANG_QUERY_KEY = "lang";

export function useLangParamUrl() {
    const page = usePage();

    const langParam = computed(() => {
        const queryStart = page.url.indexOf("?");

        if (queryStart === -1) {
            return null;
        }

        return new URLSearchParams(page.url.slice(queryStart)).get(
            LANG_QUERY_KEY,
        );
    });

    const withLangParam = (href: string) => {
        const lang = langParam.value;

        if (lang === null || lang === "") {
            return href;
        }

        const url = new URL(href, window.location.origin);
        url.searchParams.set(LANG_QUERY_KEY, lang);

        return `${url.pathname}${url.search}${url.hash}`;
    };

    return { withLangParam };
}
